export const adminPagesTranslations = {
  fr: {
    // Dashboard Principal
    dashboard: {
      title: "Tableau de bord",
      subtitle: "Vue d'ensemble de l'activité et des métriques clés",
      hero: {
        title: "Bienvenue dans l'administration",
        description: "Gérez vos utilisateurs, surveillez les coûts et optimisez l'engagement",
        stats: {
          users: "Utilisateurs",
          revenue: "MRR",
          costs: "Coûts IA",
          roi: "ROI"
        }
      },
      stats: {
        stripeSubscribers: "Abonnés Stripe",
        monthly: "mensuels",
        annual: "annuels",
        monthlyRevenue: "Revenus Mensuels (MRR)",
        activeTrials: "Essais Actifs",
        trialPeriod: "Période d'essai (7j)",
        freePremium: "Premium Gratuits",
        adminAccess: "Accès admin (€0)",
        usersList: "Liste des utilisateurs",
        usersTotal: "utilisateurs au total",
        paying: "payants",
        trials: "essais"
      }
    },
    
    // Page Utilisateurs
    users: {
      title: "Gestion des utilisateurs",
      subtitle: "Administrez les comptes, rôles et abonnements",
      hero: {
        title: "Utilisateurs",
        description: "Gérez tous les comptes utilisateurs et leurs permissions"
      },
      filters: {
        search: "Rechercher par nom ou email...",
        subscriptionStatus: "Statut abonnement",
        role: "Rôle",
        trialStatus: "Statut essai",
        dateRange: "Période"
      },
      actions: {
        export: "Exporter",
        refresh: "Actualiser",
        toggleDashboard: "Basculer vue"
      },
      audit: {
        title: "Audit des comptes",
        description: "Détection des incohérences de données",
        refresh: "Actualiser l'audit",
        recover: "Récupérer les manquants",
        issues: "problèmes détectés"
      },
      confirmations: {
        deleteTitle: "Supprimer l'utilisateur",
        deleteMessage: "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
        confirm: "Supprimer",
        cancel: "Annuler"
      }
    },
    
    // Statistiques d'utilisation
    usageStats: {
      title: "Statistiques d'utilisation",
      subtitle: "Analyse détaillée de l'utilisation de l'application",
      hero: {
        title: "Utilisation de l'application",
        description: "Suivez l'activité des utilisateurs et les tendances d'engagement"
      },
      periods: {
        today: "Aujourd'hui",
        week: "7 derniers jours",
        month: "30 derniers jours",
        all: "Tout"
      },
      metrics: {
        activeUsers: "Utilisateurs actifs",
        sessions: "Sessions",
        avgSessionDuration: "Durée moy. session",
        features: "Fonctionnalités utilisées"
      }
    },
    
    // Engagement
    engagement: {
      title: "Engagement utilisateur",
      subtitle: "Métriques de rétention et d'activité",
      hero: {
        title: "Analyse d'engagement",
        description: "Optimisez la rétention avec des données comportementales"
      },
      metrics: {
        dailyActive: "Actifs quotidiens",
        weeklyActive: "Actifs hebdomadaires",
        retention7d: "Rétention 7j",
        retention30d: "Rétention 30j",
        avgStreakDays: "Streak moyen",
        topFeature: "Fonctionnalité #1"
      }
    },
    
    // Logs système
    systemLogs: {
      title: "Logs système",
      subtitle: "Journal des événements et erreurs",
      hero: {
        title: "Surveillance système",
        description: "Consultez les logs en temps réel pour le débogage"
      },
      filters: {
        level: "Niveau",
        timeRange: "Période",
        search: "Rechercher dans les logs..."
      },
      levels: {
        all: "Tous",
        error: "Erreurs",
        warning: "Avertissements",
        info: "Info",
        debug: "Debug"
      }
    },
    
    // XP & Badges
    xpBadge: {
      title: "XP & Badges",
      subtitle: "Suivi de la gamification",
      hero: {
        title: "Système de récompenses",
        description: "Surveillez l'attribution des XP et badges"
      },
      stats: {
        totalXpAwarded: "XP total distribué",
        totalBadges: "Badges débloqués",
        avgXpPerUser: "XP moyen/utilisateur",
        topBadge: "Badge le plus populaire"
      }
    },
    
    // Notifications
    notifications: {
      title: "Notifications",
      subtitle: "Gérez vos campagnes email et push",
      hero: {
        title: "Centre de notifications",
        description: "Créez et suivez vos campagnes de notification"
      },
      confirmations: {
        deleteTemplate: "Êtes-vous sûr de vouloir supprimer ce template ?",
        deleteTemplateTitle: "Supprimer le template",
        deleteCampaign: "Êtes-vous sûr de vouloir supprimer cette campagne ?",
        deleteCampaignTitle: "Supprimer la campagne",
        confirm: "Supprimer",
        cancel: "Annuler"
      }
    },
    
    // Création de challenge
    createChallenge: {
      title: "Créer un challenge",
      subtitle: "Nouveau défi pour la communauté",
      hero: {
        title: "Challenges hebdomadaires",
        description: "Créez des défis engageants pour vos utilisateurs"
      },
      form: {
        title: "Titre du challenge",
        description: "Description",
        goal: "Objectif",
        reward: "Récompense XP",
        badge: "Badge associé",
        duration: "Durée (jours)",
        specialty: "Spécialité",
        startDate: "Date de début"
      }
    },
    
    // Nettoyage des expirés
    expiredCleanup: {
      title: "Nettoyage des comptes expirés",
      subtitle: "Gestion des utilisateurs inactifs",
      hero: {
        title: "Maintenance des comptes",
        description: "Gérez les utilisateurs avec essais expirés non convertis"
      },
      stats: {
        expiredTrials: "Essais expirés",
        pendingDeletion: "En attente de suppression",
        warningsSent: "Avertissements envoyés",
        lastCleanup: "Dernière purge"
      },
      actions: {
        sendWarnings: "Envoyer avertissements",
        deleteExpired: "Supprimer les expirés",
        viewTracking: "Voir le suivi"
      }
    },
    
    // Breadcrumbs
    breadcrumbs: {
      admin: "Administration",
      dashboard: "Tableau de bord",
      users: "Utilisateurs",
      usageStats: "Statistiques",
      engagement: "Engagement",
      aiPrompts: "Prompts IA",
      notifications: "Mailing",
      xpBadge: "XP & Badges",
      createChallenge: "Créer Challenge",
      systemLogs: "Logs",
      expiredCleanup: "Nettoyage"
    },
    aiPrompts: {
      title: 'Gestion des Prompts IA',
      description: "Gérez les templates de prompts utilisés par l'intelligence artificielle",
    },
    pushTest: {
      pageTitle: 'Test Notifications Push',
      pageDesc: 'Interface de test pour les notifications push web',
      notificationSent: 'Notification envoyée',
      notificationSentDesc: '{{count}} notification(s) envoyée(s) avec succès',
      sendError: "Erreur d'envoi",
      sendErrorDesc: "Impossible d'envoyer la notification",
      vapidTitle: 'État Configuration VAPID',
      vapidDesc: "Vérification des clés VAPID nécessaires pour l'envoi",
      vapidOk: 'VAPID configuré correctement',
      vapidNotOk: 'VAPID non configuré',
      potentialRecipients: 'Destinataires potentiels',
      checkVapid: 'Vérifier VAPID',
      tokenStats: 'Statistiques Tokens',
      totalActive: 'Total actifs',
      validWeb: 'Web valides',
      invalidWeb: 'Web invalides',
    },

    // Enhanced Metrics
    enhancedMetrics: {
      performanceScore: "Score de Performance Global",
      performance: "Performance",
      critical: "Critique",
      excellent: "Excellent",
      responseTime: "Temps de Réponse",
      fast: "Rapide",
      correct: "Correct",
      slow: "Lent",
      errorRate: "Taux d'Erreur",
      good: "Bon",
      toImprove: "À améliorer",
      costEfficiency: "Efficacité Coût",
      tokensPerCent: "tokens/centime",
      throughput: "Débit",
      tokensPerSecond: "tokens/seconde",
      weeklyTrend: "Tendance 7j",
      vsPreviousWeek: "vs semaine précédente",
      availability: "Disponibilité",
      temporalCoverage: "Couverture temporelle",
      modelDistribution: "Distribution des Modèles",
      modelDistributionDesc: "Utilisation par modèle IA cette semaine"
    },

    // Detailed Metrics
    detailedMetrics: {
      mostExpensive: "Usage le plus coûteux",
      mostUsed: "Usage le plus fréquent",
      queries: "requêtes",
      tokensInOut: "Tokens In/Out",
      ratio: "Ratio",
      efficiency: "Efficacité",
      reqPerEuro: "req/€ (×1000)"
    },

    // User Subscription Dashboard
    subscriptionDashboard: {
      detailTitle: "Détail des abonnements",
      detailDesc: "Liste des utilisateurs avec leurs informations d'abonnement Stripe",
      email: "Email",
      status: "Statut",
      amount: "Montant",
      type: "Type",
      registeredOn: "Inscrit le",
      realAmountsAfterPromos: "Montants réels après promos",
      trialToSubscription: "Essai → Abonnement payant",
      paidPlusTrial: "Payants + Essai",
      expiredToReconquer: "Essais expirés à relancer",
      monthlySubscribers: "Mensuels",
      annualSubscribers: "Annuels (6,66€/mois)",
      onTrial: "En essai (7j)",
      expiredTrials: "Essais expirés",
      freeUsers: "Gratuits",
      userDistribution: "Répartition des utilisateurs",
      distributionByStatus: "Distribution par statut d'abonnement",
      subscriptionEvolution: "Évolution des abonnements",
      newSubscribersPerMonth: "Nouveaux abonnés par mois (6 derniers mois)",
      andMore: "... et {{count}} autres utilisateurs",
      unlinkedStripe: "Abonnés Stripe sans compte",
      unlinkedStripeDesc: "Ces personnes paient mais n'ont pas de compte Supabase correspondant",
      tier: "Tier",
      action: "Action",
      createManualAccount: "Créer compte manuel requis",
      monthly: "Mensuel",
      annual: "Annuel",
      mrr: "Revenus Mensuels (MRR)",
      notSynced: "Non sync",
      conversionRate: "Taux de conversion",
      activeUsers: "Utilisateurs actifs",
      toReconquer: "À reconquérir"
    },

    // Cost Breakdown Charts
    costBreakdown: {
      cost: "Coût",
      requests: "Requêtes",
      ofTotal: "du total",
      costByUsage: "Coûts par type d'usage",
      costByModel: "Coûts par modèle IA",
      costByUsageType: "Détail des coûts par usage",
      usageType: "Type d'usage",
      costPerReq: "Coût/req"
    },

    // Email Queue
    emailQueue: {
      title: "File d'attente emails",
      pending: "En attente",
      processing: "En cours",
      sent: "Envoyés",
      failures: "Échecs",
      sendingInProgress: "Envoi en cours... (~{{minutes}} min restantes)",
      noEmailPending: "Aucun email en attente"
    },

    // Scheduled Campaigns
    campaigns: {
      scheduledTitle: "Campagnes programmées",
      noneScheduled: "Aucune campagne programmée",
      autoSendNote: "Les campagnes seront envoyées automatiquement à la date prévue",
      autoSendDesc: "Le système enverra automatiquement ces campagnes à l'heure prévue",
      scheduled: "Programmée",
      noSubject: "Pas de sujet",
      allUsers: "Tous",
      unknownDate: "Date inconnue",
      awaitingSend: "En attente d'envoi",
      inDaysHours: "Dans {{days}}j {{hours}}h",
      inHoursMin: "Dans {{hours}}h {{minutes}}min",
      inMinutes: "Dans {{minutes}}min",
      cronNote: "Le job CRON vérifie toutes les 5 minutes et envoie automatiquement les campagnes prêtes",
    },

    quickEmail: {
      sendNotification: "Envoyer une notification",
      createAndSend: "Créez et envoyez rapidement des emails à vos utilisateurs",
      directEmail: "Email direct",
      useTemplate: "Utiliser un template",
      selectTemplate: "Sélectionner un template",
      chooseTemplate: "Choisir un template...",
      campaignName: "Nom de la campagne (optionnel)",
      campaignNamePlaceholder: "Ex: Annonce nouvelles fonctionnalités",
      targetAudience: "Audience cible",
      testEmailLabel: "Adresse email de test",
      testEmailPlaceholder: "test@exemple.com",
      recipients: "destinataires",
      sendEstimate: "Envoi estimé en ~{{days}} jour(s) (limite: {{limit}}/jour)",
      emailSubject: "Sujet de l'email",
      emailSubjectPlaceholder: "🚀 Découvrez les nouveautés !",
      htmlContent: "Contenu HTML",
      preview: "Aperçu",
      availableVars: "Variables disponibles",
      scheduleLabel: "Programmer l'envoi (optionnel)",
      sendNow: "Envoyer maintenant",
      scheduleSend: "Programmer l'envoi",
      sending: "Envoi en cours...",
      campaignSent: "Campagne envoyée !",
      campaignSentDesc: "{{count}} emails mis en file d'attente. Estimation: ~{{days}} jour(s)",
      campaignScheduled: "Campagne programmée",
      campaignScheduledDesc: "Envoi prévu le {{date}}",
      sendError: "Impossible d'envoyer la campagne",
      fillSubjectContent: "Veuillez remplir le sujet et le contenu",
      subjectNotEmail: "Le sujet ne peut pas être une adresse email",
      mustBeConnected: "Vous devez être connecté",
      invalidTestEmail: "Veuillez entrer une adresse email valide pour le test",
      emailPreview: "Aperçu de l'email",
      subject: "Sujet",
      largeWarning: "Cette campagne sera envoyée progressivement sur {{days}} jour(s) pour respecter la limite de {{limit}} emails/jour."
    },
    
    // Messages communs
    common: {
      loading: "Chargement...",
      refreshing: "Actualisation...",
      noData: "Aucune donnée disponible",
      error: "Une erreur est survenue",
      success: "Opération réussie",
      confirm: "Confirmer",
      cancel: "Annuler",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
      export: "Exporter"
    },
    toasts: {
      challengeCreated: "Challenge créé avec succès !",
      challengeError: "Erreur lors de la création du challenge",
      logsError: "Erreur lors du chargement des logs",
      logsRefreshed: "Logs actualisés",
      logsRefreshError: "Erreur lors de l'actualisation",
      usersLoadError: "Erreur lors du chargement des utilisateurs",
      unauthorized: "Accès non autorisé",
      trialExtended: "Période d'essai prolongée de 7 jours",
      trialExtendError: "Erreur lors de la prolongation de l'essai",
      userDeleted: "Utilisateur supprimé avec succès",
      userDeleteError: "Erreur lors de la suppression de l'utilisateur",
      secretsOk: "Configuration des secrets OK",
      auditError: "Erreur lors de l'audit des utilisateurs",
      noMissingUsers: "Aucun utilisateur manquant à récupérer",
      recoverError: "Erreur lors de la récupération des utilisateurs",
      stripeSynced: "Données Stripe synchronisées",
      stripeSyncError: "Erreur lors de la synchronisation",
      featureInDev: "Fonctionnalité en développement",
      usageLoadError: "Erreur lors du chargement des statistiques d'utilisation",
      dataRefreshed: "Données actualisées",
      refreshError: "Erreur lors de l'actualisation",
      dataUpdated: "Données mises à jour"
    }
  },
  
  en: {
    dashboard: {
      title: "Dashboard",
      subtitle: "Overview of activity and key metrics",
      hero: {
        title: "Welcome to administration",
        description: "Manage your users, monitor costs and optimize engagement",
        stats: {
          users: "Users",
          revenue: "MRR",
          costs: "AI Costs",
          roi: "ROI"
        }
      },
      stats: {
        stripeSubscribers: "Stripe Subscribers",
        monthly: "monthly",
        annual: "annual",
        monthlyRevenue: "Monthly Revenue (MRR)",
        activeTrials: "Active Trials",
        trialPeriod: "Trial period (7d)",
        freePremium: "Free Premium",
        adminAccess: "Admin access (€0)",
        usersList: "Users list",
        usersTotal: "total users",
        paying: "paying",
        trials: "trials"
      }
    },
    
    users: {
      title: "User management",
      subtitle: "Administer accounts, roles and subscriptions",
      hero: {
        title: "Users",
        description: "Manage all user accounts and their permissions"
      },
      filters: {
        search: "Search by name or email...",
        subscriptionStatus: "Subscription status",
        role: "Role",
        trialStatus: "Trial status",
        dateRange: "Period"
      },
      actions: {
        export: "Export",
        refresh: "Refresh",
        toggleDashboard: "Toggle view"
      },
      audit: {
        title: "Account audit",
        description: "Data inconsistency detection",
        refresh: "Refresh audit",
        recover: "Recover missing",
        issues: "issues detected"
      },
      confirmations: {
        deleteTitle: "Delete User",
        deleteMessage: "Are you sure you want to delete this user? This action cannot be undone.",
        confirm: "Delete",
        cancel: "Cancel"
      }
    },
    
    usageStats: {
      title: "Usage statistics",
      subtitle: "Detailed analysis of application usage",
      hero: {
        title: "Application usage",
        description: "Track user activity and engagement trends"
      },
      periods: {
        today: "Today",
        week: "Last 7 days",
        month: "Last 30 days",
        all: "All"
      },
      metrics: {
        activeUsers: "Active users",
        sessions: "Sessions",
        avgSessionDuration: "Avg. session duration",
        features: "Features used"
      }
    },
    
    engagement: {
      title: "User engagement",
      subtitle: "Retention and activity metrics",
      hero: {
        title: "Engagement analysis",
        description: "Optimize retention with behavioral data"
      },
      metrics: {
        dailyActive: "Daily active",
        weeklyActive: "Weekly active",
        retention7d: "7d retention",
        retention30d: "30d retention",
        avgStreakDays: "Avg. streak",
        topFeature: "#1 feature"
      }
    },
    
    systemLogs: {
      title: "System logs",
      subtitle: "Event and error journal",
      hero: {
        title: "System monitoring",
        description: "View real-time logs for debugging"
      },
      filters: {
        level: "Level",
        timeRange: "Period",
        search: "Search logs..."
      },
      levels: {
        all: "All",
        error: "Errors",
        warning: "Warnings",
        info: "Info",
        debug: "Debug"
      }
    },
    
    xpBadge: {
      title: "XP & Badges",
      subtitle: "Gamification tracking",
      hero: {
        title: "Reward system",
        description: "Monitor XP and badge attribution"
      },
      stats: {
        totalXpAwarded: "Total XP awarded",
        totalBadges: "Badges unlocked",
        avgXpPerUser: "Avg. XP/user",
        topBadge: "Most popular badge"
      }
    },
    
    notifications: {
      title: "Notifications",
      subtitle: "Manage your email and push campaigns",
      hero: {
        title: "Notification center",
        description: "Create and track your notification campaigns"
      },
      confirmations: {
        deleteTemplate: "Are you sure you want to delete this template?",
        deleteTemplateTitle: "Delete template",
        deleteCampaign: "Are you sure you want to delete this campaign?",
        deleteCampaignTitle: "Delete campaign",
        confirm: "Delete",
        cancel: "Cancel"
      }
    },
    
    createChallenge: {
      title: "Create challenge",
      subtitle: "New challenge for the community",
      hero: {
        title: "Weekly challenges",
        description: "Create engaging challenges for your users"
      },
      form: {
        title: "Challenge title",
        description: "Description",
        goal: "Goal",
        reward: "XP reward",
        badge: "Associated badge",
        duration: "Duration (days)",
        specialty: "Specialty",
        startDate: "Start date"
      }
    },
    
    expiredCleanup: {
      title: "Expired account cleanup",
      subtitle: "Inactive user management",
      hero: {
        title: "Account maintenance",
        description: "Manage users with expired unconverted trials"
      },
      stats: {
        expiredTrials: "Expired trials",
        pendingDeletion: "Pending deletion",
        warningsSent: "Warnings sent",
        lastCleanup: "Last cleanup"
      },
      actions: {
        sendWarnings: "Send warnings",
        deleteExpired: "Delete expired",
        viewTracking: "View tracking"
      }
    },
    
    breadcrumbs: {
      admin: "Administration",
      dashboard: "Dashboard",
      users: "Users",
      usageStats: "Statistics",
      engagement: "Engagement",
      aiPrompts: "AI Prompts",
      notifications: "Mailing",
      xpBadge: "XP & Badges",
      createChallenge: "Create Challenge",
      systemLogs: "Logs",
      expiredCleanup: "Cleanup"
    },
    aiPrompts: {
      title: 'AI Prompts Management',
      description: 'Manage prompt templates used by artificial intelligence',
    },
    pushTest: {
      pageTitle: 'Push Notifications Test',
      pageDesc: 'Test interface for web push notifications',
      notificationSent: 'Notification sent',
      notificationSentDesc: '{{count}} notification(s) sent successfully',
      sendError: 'Send error',
      sendErrorDesc: 'Unable to send notification',
      vapidTitle: 'VAPID Configuration Status',
      vapidDesc: 'Checking VAPID keys required for sending',
      vapidOk: 'VAPID configured correctly',
      vapidNotOk: 'VAPID not configured',
      potentialRecipients: 'Potential recipients',
      checkVapid: 'Check VAPID',
      tokenStats: 'Token Statistics',
      totalActive: 'Total active',
      validWeb: 'Valid web',
      invalidWeb: 'Invalid web',
    },

    enhancedMetrics: {
      performanceScore: "Global Performance Score",
      performance: "Performance",
      critical: "Critical",
      excellent: "Excellent",
      responseTime: "Response Time",
      fast: "Fast",
      correct: "Correct",
      slow: "Slow",
      errorRate: "Error Rate",
      good: "Good",
      toImprove: "Needs improvement",
      costEfficiency: "Cost Efficiency",
      tokensPerCent: "tokens/cent",
      throughput: "Throughput",
      tokensPerSecond: "tokens/second",
      weeklyTrend: "7d Trend",
      vsPreviousWeek: "vs previous week",
      availability: "Availability",
      temporalCoverage: "Temporal coverage",
      modelDistribution: "Model Distribution",
      modelDistributionDesc: "Usage by AI model this week"
    },

    detailedMetrics: {
      mostExpensive: "Most expensive usage",
      mostUsed: "Most used",
      queries: "queries",
      tokensInOut: "Tokens In/Out",
      ratio: "Ratio",
      efficiency: "Efficiency",
      reqPerEuro: "req/€ (×1000)"
    },

    subscriptionDashboard: {
      detailTitle: "Subscription Details",
      detailDesc: "Users list with Stripe subscription information",
      email: "Email",
      status: "Status",
      amount: "Amount",
      type: "Type",
      registeredOn: "Registered on",
      realAmountsAfterPromos: "Real amounts after promos",
      trialToSubscription: "Trial → Paid subscription",
      paidPlusTrial: "Paid + Trial",
      expiredToReconquer: "Expired trials to re-engage",
      monthlySubscribers: "Monthly",
      annualSubscribers: "Annual (6.66€/mo)",
      onTrial: "On trial (7d)",
      expiredTrials: "Expired trials",
      freeUsers: "Free",
      userDistribution: "User Distribution",
      distributionByStatus: "Distribution by subscription status",
      subscriptionEvolution: "Subscription Evolution",
      newSubscribersPerMonth: "New subscribers per month (last 6 months)",
      andMore: "... and {{count}} more users",
      unlinkedStripe: "Stripe subscribers without account",
      unlinkedStripeDesc: "These people pay but don't have a corresponding Supabase account",
      tier: "Tier",
      action: "Action",
      createManualAccount: "Manual account creation required",
      monthly: "Monthly",
      annual: "Annual",
      mrr: "Monthly Revenue (MRR)",
      notSynced: "Not synced",
      conversionRate: "Conversion Rate",
      activeUsers: "Active Users",
      toReconquer: "To Re-engage"
    },

    costBreakdown: {
      cost: "Cost",
      requests: "Requests",
      ofTotal: "of total",
      costByUsage: "Costs by usage type",
      costByModel: "Costs by AI model",
      costByUsageType: "Cost details by usage",
      usageType: "Usage type",
      costPerReq: "Cost/req"
    },

    emailQueue: {
      title: "Email Queue",
      pending: "Pending",
      processing: "Processing",
      sent: "Sent",
      failures: "Failed",
      sendingInProgress: "Sending... (~{{minutes}} min remaining)",
      noEmailPending: "No pending emails"
    },

    campaigns: {
      scheduledTitle: "Scheduled campaigns",
      noneScheduled: "No scheduled campaigns",
      autoSendNote: "Campaigns will be sent automatically at the scheduled date",
      autoSendDesc: "The system will automatically send these campaigns at the scheduled time",
      scheduled: "Scheduled",
      noSubject: "No subject",
      allUsers: "All",
      unknownDate: "Unknown date",
      awaitingSend: "Awaiting send",
      inDaysHours: "In {{days}}d {{hours}}h",
      inHoursMin: "In {{hours}}h {{minutes}}min",
      inMinutes: "In {{minutes}}min",
      cronNote: "The CRON job checks every 5 minutes and automatically sends ready campaigns",
    },

    quickEmail: {
      sendNotification: "Send a notification",
      createAndSend: "Quickly create and send emails to your users",
      directEmail: "Direct email",
      useTemplate: "Use a template",
      selectTemplate: "Select a template",
      chooseTemplate: "Choose a template...",
      campaignName: "Campaign name (optional)",
      campaignNamePlaceholder: "E.g.: New features announcement",
      targetAudience: "Target audience",
      testEmailLabel: "Test email address",
      testEmailPlaceholder: "test@example.com",
      recipients: "recipients",
      sendEstimate: "Estimated delivery over ~{{days}} day(s) (limit: {{limit}}/day)",
      emailSubject: "Email subject",
      emailSubjectPlaceholder: "🚀 Check out what's new!",
      htmlContent: "HTML Content",
      preview: "Preview",
      availableVars: "Available variables",
      scheduleLabel: "Schedule send (optional)",
      sendNow: "Send now",
      scheduleSend: "Schedule send",
      sending: "Sending...",
      campaignSent: "Campaign sent!",
      campaignSentDesc: "{{count}} emails queued. Estimate: ~{{days}} day(s)",
      campaignScheduled: "Campaign scheduled",
      campaignScheduledDesc: "Scheduled for {{date}}",
      sendError: "Unable to send campaign",
      fillSubjectContent: "Please fill in the subject and content",
      subjectNotEmail: "The subject cannot be an email address",
      mustBeConnected: "You must be logged in",
      invalidTestEmail: "Please enter a valid test email address",
      emailPreview: "Email Preview",
      subject: "Subject",
      largeWarning: "This campaign will be sent progressively over {{days}} day(s) to respect the {{limit}} emails/day limit."
    },
    
    common: {
      loading: "Loading...",
      refreshing: "Refreshing...",
      noData: "No data available",
      error: "An error occurred",
      success: "Operation successful",
      confirm: "Confirm",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      export: "Export"
    },
    toasts: {
      challengeCreated: "Challenge created successfully!",
      challengeError: "Error creating challenge",
      logsError: "Error loading logs",
      logsRefreshed: "Logs refreshed",
      logsRefreshError: "Error refreshing",
      usersLoadError: "Error loading users",
      unauthorized: "Unauthorized access",
      trialExtended: "Trial extended by 7 days",
      trialExtendError: "Error extending trial",
      userDeleted: "User deleted successfully",
      userDeleteError: "Error deleting user",
      secretsOk: "Secrets configuration OK",
      auditError: "Error auditing users",
      noMissingUsers: "No missing users to recover",
      recoverError: "Error recovering users",
      stripeSynced: "Stripe data synchronized",
      stripeSyncError: "Error synchronizing",
      featureInDev: "Feature in development",
      usageLoadError: "Error loading usage statistics",
      dataRefreshed: "Data refreshed",
      refreshError: "Error refreshing",
      dataUpdated: "Data updated"
    }
  },
  
  es: {
    dashboard: {
      title: "Panel de control",
      subtitle: "Resumen de actividad y métricas clave",
      hero: {
        title: "Bienvenido a la administración",
        description: "Gestiona tus usuarios, supervisa costos y optimiza el engagement",
        stats: {
          users: "Usuarios",
          revenue: "MRR",
          costs: "Costos IA",
          roi: "ROI"
        }
      },
      stats: {
        stripeSubscribers: "Suscriptores Stripe",
        monthly: "mensuales",
        annual: "anuales",
        monthlyRevenue: "Ingresos Mensuales (MRR)",
        activeTrials: "Pruebas Activas",
        trialPeriod: "Período de prueba (7d)",
        freePremium: "Premium Gratuito",
        adminAccess: "Acceso admin (€0)",
        usersList: "Lista de usuarios",
        usersTotal: "usuarios en total",
        paying: "de pago",
        trials: "pruebas"
      }
    },
    
    users: {
      title: "Gestión de usuarios",
      subtitle: "Administra cuentas, roles y suscripciones",
      hero: {
        title: "Usuarios",
        description: "Gestiona todas las cuentas de usuario y sus permisos"
      },
      filters: {
        search: "Buscar por nombre o email...",
        subscriptionStatus: "Estado suscripción",
        role: "Rol",
        trialStatus: "Estado prueba",
        dateRange: "Período"
      },
      actions: {
        export: "Exportar",
        refresh: "Actualizar",
        toggleDashboard: "Cambiar vista"
      },
      audit: {
        title: "Auditoría de cuentas",
        description: "Detección de inconsistencias de datos",
        refresh: "Actualizar auditoría",
        recover: "Recuperar faltantes",
        issues: "problemas detectados"
      },
      confirmations: {
        deleteTitle: "Eliminar Usuario",
        deleteMessage: "¿Está seguro de que desea eliminar este usuario? Esta acción no se puede deshacer.",
        confirm: "Eliminar",
        cancel: "Cancelar"
      }
    },
    
    usageStats: {
      title: "Estadísticas de uso",
      subtitle: "Análisis detallado del uso de la aplicación",
      hero: {
        title: "Uso de la aplicación",
        description: "Rastrea la actividad de usuarios y tendencias de engagement"
      },
      periods: {
        today: "Hoy",
        week: "Últimos 7 días",
        month: "Últimos 30 días",
        all: "Todo"
      },
      metrics: {
        activeUsers: "Usuarios activos",
        sessions: "Sesiones",
        avgSessionDuration: "Duración prom. sesión",
        features: "Funciones usadas"
      }
    },
    
    engagement: {
      title: "Engagement de usuarios",
      subtitle: "Métricas de retención y actividad",
      hero: {
        title: "Análisis de engagement",
        description: "Optimiza la retención con datos de comportamiento"
      },
      metrics: {
        dailyActive: "Activos diarios",
        weeklyActive: "Activos semanales",
        retention7d: "Retención 7d",
        retention30d: "Retención 30d",
        avgStreakDays: "Racha promedio",
        topFeature: "Función #1"
      }
    },
    
    systemLogs: {
      title: "Logs del sistema",
      subtitle: "Registro de eventos y errores",
      hero: {
        title: "Monitoreo del sistema",
        description: "Consulta logs en tiempo real para depuración"
      },
      filters: {
        level: "Nivel",
        timeRange: "Período",
        search: "Buscar en logs..."
      },
      levels: {
        all: "Todos",
        error: "Errores",
        warning: "Advertencias",
        info: "Info",
        debug: "Debug"
      }
    },
    
    xpBadge: {
      title: "XP e Insignias",
      subtitle: "Seguimiento de gamificación",
      hero: {
        title: "Sistema de recompensas",
        description: "Supervisa la atribución de XP e insignias"
      },
      stats: {
        totalXpAwarded: "XP total otorgado",
        totalBadges: "Insignias desbloqueadas",
        avgXpPerUser: "XP prom./usuario",
        topBadge: "Insignia más popular"
      }
    },
    
    notifications: {
      title: "Notificaciones",
      subtitle: "Gestione sus campañas email y push",
      hero: {
        title: "Centro de notificaciones",
        description: "Cree y rastree sus campañas de notificación"
      },
      confirmations: {
        deleteTemplate: "¿Está seguro de que desea eliminar esta plantilla?",
        deleteTemplateTitle: "Eliminar plantilla",
        deleteCampaign: "¿Está seguro de que desea eliminar esta campaña?",
        deleteCampaignTitle: "Eliminar campaña",
        confirm: "Eliminar",
        cancel: "Cancelar"
      }
    },
    
    createChallenge: {
      title: "Crear desafío",
      subtitle: "Nuevo desafío para la comunidad",
      hero: {
        title: "Desafíos semanales",
        description: "Crea desafíos atractivos para tus usuarios"
      },
      form: {
        title: "Título del desafío",
        description: "Descripción",
        goal: "Objetivo",
        reward: "Recompensa XP",
        badge: "Insignia asociada",
        duration: "Duración (días)",
        specialty: "Especialidad",
        startDate: "Fecha de inicio"
      }
    },
    
    expiredCleanup: {
      title: "Limpieza de cuentas expiradas",
      subtitle: "Gestión de usuarios inactivos",
      hero: {
        title: "Mantenimiento de cuentas",
        description: "Gestiona usuarios con pruebas expiradas no convertidas"
      },
      stats: {
        expiredTrials: "Pruebas expiradas",
        pendingDeletion: "Pendientes de eliminación",
        warningsSent: "Advertencias enviadas",
        lastCleanup: "Última limpieza"
      },
      actions: {
        sendWarnings: "Enviar advertencias",
        deleteExpired: "Eliminar expirados",
        viewTracking: "Ver seguimiento"
      }
    },
    
    breadcrumbs: {
      admin: "Administración",
      dashboard: "Panel",
      users: "Usuarios",
      usageStats: "Estadísticas",
      engagement: "Engagement",
      aiPrompts: "Prompts IA",
      notifications: "Mailing",
      xpBadge: "XP e Insignias",
      createChallenge: "Crear Desafío",
      systemLogs: "Logs",
      expiredCleanup: "Limpieza"
    },
    aiPrompts: {
      title: 'Gestión de Prompts IA',
      description: 'Gestione las plantillas de prompts utilizadas por la inteligencia artificial',
    },
    pushTest: {
      pageTitle: 'Test de Notificaciones Push',
      pageDesc: 'Interfaz de prueba para notificaciones push web',
      notificationSent: 'Notificación enviada',
      notificationSentDesc: '{{count}} notificación(es) enviada(s) con éxito',
      sendError: 'Error de envío',
      sendErrorDesc: 'No se pudo enviar la notificación',
      vapidTitle: 'Estado de Configuración VAPID',
      vapidDesc: 'Verificación de claves VAPID necesarias para el envío',
      vapidOk: 'VAPID configurado correctamente',
      vapidNotOk: 'VAPID no configurado',
      potentialRecipients: 'Destinatarios potenciales',
      checkVapid: 'Verificar VAPID',
      tokenStats: 'Estadísticas de Tokens',
      totalActive: 'Total activos',
      validWeb: 'Web válidos',
      invalidWeb: 'Web inválidos',
    },

    enhancedMetrics: {
      performanceScore: "Puntuación de Rendimiento Global",
      performance: "Rendimiento",
      critical: "Crítico",
      excellent: "Excelente",
      responseTime: "Tiempo de Respuesta",
      fast: "Rápido",
      correct: "Correcto",
      slow: "Lento",
      errorRate: "Tasa de Error",
      good: "Bueno",
      toImprove: "A mejorar",
      costEfficiency: "Eficiencia de Costos",
      tokensPerCent: "tokens/céntimo",
      throughput: "Rendimiento",
      tokensPerSecond: "tokens/segundo",
      weeklyTrend: "Tendencia 7d",
      vsPreviousWeek: "vs semana anterior",
      availability: "Disponibilidad",
      temporalCoverage: "Cobertura temporal",
      modelDistribution: "Distribución de Modelos",
      modelDistributionDesc: "Uso por modelo IA esta semana"
    },

    detailedMetrics: {
      mostExpensive: "Uso más costoso",
      mostUsed: "Más utilizado",
      queries: "consultas",
      tokensInOut: "Tokens In/Out",
      ratio: "Ratio",
      efficiency: "Eficiencia",
      reqPerEuro: "req/€ (×1000)"
    },

    subscriptionDashboard: {
      detailTitle: "Detalle de suscripciones",
      detailDesc: "Lista de usuarios con información de suscripción Stripe",
      email: "Email",
      status: "Estado",
      amount: "Monto",
      type: "Tipo",
      registeredOn: "Registrado el",
      realAmountsAfterPromos: "Montos reales después de promos",
      trialToSubscription: "Prueba → Suscripción de pago",
      paidPlusTrial: "De pago + Prueba",
      expiredToReconquer: "Pruebas expiradas a reconquistar",
      monthlySubscribers: "Mensuales",
      annualSubscribers: "Anuales (6,66€/mes)",
      onTrial: "En prueba (7d)",
      expiredTrials: "Pruebas expiradas",
      freeUsers: "Gratuitos",
      userDistribution: "Distribución de usuarios",
      distributionByStatus: "Distribución por estado de suscripción",
      subscriptionEvolution: "Evolución de suscripciones",
      newSubscribersPerMonth: "Nuevos suscriptores por mes (últimos 6 meses)",
      andMore: "... y {{count}} usuarios más",
      unlinkedStripe: "Suscriptores Stripe sin cuenta",
      unlinkedStripeDesc: "Estas personas pagan pero no tienen una cuenta Supabase correspondiente",
      tier: "Nivel",
      action: "Acción",
      createManualAccount: "Creación de cuenta manual requerida",
      monthly: "Mensual",
      annual: "Anual",
      mrr: "Ingresos Mensuales (MRR)",
      notSynced: "No sincronizado",
      conversionRate: "Tasa de conversión",
      activeUsers: "Usuarios activos",
      toReconquer: "A reconquistar"
    },

    costBreakdown: {
      cost: "Costo",
      requests: "Consultas",
      ofTotal: "del total",
      costByUsage: "Costos por tipo de uso",
      costByModel: "Costos por modelo IA",
      costByUsageType: "Detalle de costos por uso",
      usageType: "Tipo de uso",
      costPerReq: "Costo/consulta"
    },

    emailQueue: {
      title: "Cola de emails",
      pending: "Pendientes",
      processing: "En proceso",
      sent: "Enviados",
      failures: "Fallos",
      sendingInProgress: "Enviando... (~{{minutes}} min restantes)",
      noEmailPending: "Sin emails pendientes"
    },

    campaigns: {
      scheduledTitle: "Campañas programadas",
      noneScheduled: "Sin campañas programadas",
      autoSendNote: "Las campañas se enviarán automáticamente en la fecha prevista",
      autoSendDesc: "El sistema enviará automáticamente estas campañas a la hora prevista",
      scheduled: "Programada",
      noSubject: "Sin asunto",
      allUsers: "Todos",
      unknownDate: "Fecha desconocida",
      awaitingSend: "Esperando envío",
      inDaysHours: "En {{days}}d {{hours}}h",
      inHoursMin: "En {{hours}}h {{minutes}}min",
      inMinutes: "En {{minutes}}min",
      cronNote: "El job CRON verifica cada 5 minutos y envía automáticamente las campañas listas",
    },

    quickEmail: {
      sendNotification: "Enviar una notificación",
      createAndSend: "Crea y envía rápidamente emails a tus usuarios",
      directEmail: "Email directo",
      useTemplate: "Usar plantilla",
      selectTemplate: "Seleccionar plantilla",
      chooseTemplate: "Elegir plantilla...",
      campaignName: "Nombre de campaña (opcional)",
      campaignNamePlaceholder: "Ej: Anuncio nuevas funcionalidades",
      targetAudience: "Audiencia objetivo",
      testEmailLabel: "Dirección de email de prueba",
      testEmailPlaceholder: "test@ejemplo.com",
      recipients: "destinatarios",
      sendEstimate: "Envío estimado en ~{{days}} día(s) (límite: {{limit}}/día)",
      emailSubject: "Asunto del email",
      emailSubjectPlaceholder: "🚀 ¡Descubre las novedades!",
      htmlContent: "Contenido HTML",
      preview: "Vista previa",
      availableVars: "Variables disponibles",
      scheduleLabel: "Programar envío (opcional)",
      sendNow: "Enviar ahora",
      scheduleSend: "Programar envío",
      sending: "Enviando...",
      campaignSent: "¡Campaña enviada!",
      campaignSentDesc: "{{count}} emails en cola. Estimación: ~{{days}} día(s)",
      campaignScheduled: "Campaña programada",
      campaignScheduledDesc: "Envío previsto el {{date}}",
      sendError: "No se puede enviar la campaña",
      fillSubjectContent: "Por favor complete el asunto y contenido",
      subjectNotEmail: "El asunto no puede ser una dirección de email",
      mustBeConnected: "Debe estar conectado",
      invalidTestEmail: "Ingrese una dirección de email de prueba válida",
      emailPreview: "Vista previa del email",
      subject: "Asunto",
      largeWarning: "Esta campaña se enviará progresivamente en {{days}} día(s) para respetar el límite de {{limit}} emails/día."
    },
    
    common: {
      loading: "Cargando...",
      refreshing: "Actualizando...",
      noData: "No hay datos disponibles",
      error: "Ocurrió un error",
      success: "Operación exitosa",
      confirm: "Confirmar",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      close: "Cerrar",
      export: "Exportar"
    },
    toasts: {
      challengeCreated: "¡Desafío creado exitosamente!",
      challengeError: "Error al crear el desafío",
      logsError: "Error al cargar los logs",
      logsRefreshed: "Logs actualizados",
      logsRefreshError: "Error al actualizar",
      usersLoadError: "Error al cargar los usuarios",
      unauthorized: "Acceso no autorizado",
      trialExtended: "Prueba extendida por 7 días",
      trialExtendError: "Error al extender la prueba",
      userDeleted: "Usuario eliminado exitosamente",
      userDeleteError: "Error al eliminar el usuario",
      secretsOk: "Configuración de secretos OK",
      auditError: "Error al auditar usuarios",
      noMissingUsers: "No hay usuarios faltantes para recuperar",
      recoverError: "Error al recuperar usuarios",
      stripeSynced: "Datos de Stripe sincronizados",
      stripeSyncError: "Error al sincronizar",
      featureInDev: "Funcionalidad en desarrollo",
      usageLoadError: "Error al cargar estadísticas de uso",
      dataRefreshed: "Datos actualizados",
      refreshError: "Error al actualizar",
      dataUpdated: "Datos actualizados"
    }
  }
};
